import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DateConverter = (date: string): string => {
  const localTime = dayjs(date)
    .tz(dayjs.tz.guess())
    .format("YYYY-MM-DD HH:mm:ss");

  return localTime;
};
